
/**
 * Encode OData query parameters in a URL.
 * @param {string} resource - The URL containing OData query parameters.
 * @returns {string} - The URL with encoded OData query parameters.
 */
export const EncodeODataQuery = (resource) => {
    // Split the URL into base and query string
    let [baseUrl, query] = resource.split("?");

    // If there's a query string, process it
    if (query) {
        query = query
            .split("&") // split into individual parameters
            .map(param => {
                const idx = param.indexOf("="); // find first "=" 
                // If no "=", return the param as is (no value to encode)
                if (idx === -1) {
                    return encodeURIComponent(param); // param without value
                }
                // Split into key and value, encode the value
                const key = param.substring(0, idx);
                // Handle empty values correctly
                const rawValue = param.substring(idx + 1);
                // Decode first to avoid double encoding, then encode
                // If rawValue is empty, keep it as empty
                const value = rawValue === "" ? "" : encodeURIComponent(decodeURIComponent(rawValue));

                // Reconstruct the parameter
                return `${key}=${value}`;
            })
            .join("&");

        // Reconstruct the full URL
        resource = `${baseUrl}?${query}`;
    }

    // Return the encoded resource
    return resource;
};
